import useAPI from '@/hooks/useAPI';
import PersonRepository from '@/repositories/PersonRepository/PersonRepository';

const useSSIEligibilityDetails = (personId: string, enabled = true) => {
  const personRepository = PersonRepository();

  return useAPI({
    queryKey: ['getSSIEligibilityDetails', personId],
    queryFn: async () => {
      return await personRepository.getSSIEligibilityDetails(personId);
    },
    enabled: enabled && !!personId
  });
};

export default useSSIEligibilityDetails;
